// extracted by mini-css-extract-plugin
export var tosLink = "_91-0";